<template>
  <transition name="fade">
    <div class="w-login">
      <span class="w-login__title">{{title}}</span>
      <div class="w-login__input">
        <div class="w-login__input_icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-yonghu"></use>
          </svg>
        </div>
        <input type="input" maxlength="18" v-model="form.username" placeholder=" UserName" />
      </div>
      <div class="w-login__input">
        <div class="w-login__input_icon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-suoding"></use>
          </svg>
        </div>
        <input type="password" maxlength="18" v-model="form.password" placeholder=" Password" @keyup.enter="click" />
      </div>
      <div class="w-login__remember">
        <svg class="icon remember" v-if="false" aria-hidden="true" @click="remembered">
          <use :xlink:href="form.remember ? '#icon-checkbox' : '#icon-checkboxblank'"></use>
        </svg>
        <span class="remember" v-if="false" @click="remembered">Auto Login</span>
        <span class="demo">
          <a v-if="demoVisible" :href="demoLink">我要体验>></a>
        </span>
      </div>
      <div class="w-login__btn">
        <button type="button" @click="click" :class="loading ? 'loading' : ''">
          <svg class="icon icon-loading" aria-hidden="true" v-if="loading">
            <use xlink:href="#icon-loading"></use>
          </svg>
          Login</button>
      </div>
      <transition name="scale">
        <div class="w-login__error" v-if="error">{{error}}</div>
      </transition>
      <div class="w-login__options" v-if="false">
        <div class="w-login__options_flex">
          <span>Forgot Password?</span>
          <a href="/ForgetPsw.aspx">找回密码</a>
        </div>
        <w-split gap="8px" align="30px" color="#FFF"></w-split>
        <div class="w-login__options_flex">
          <span>New Account?</span>
          <a href="/Register1.aspx">Sign up</a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import WSplit from './w-split'
import { error } from 'util';
  export default {
    components: {
      WSplit
    },
    props: {
      title: {
        type: String,
        default: 'Login'
      },
      form: {
        type: Object,
        default: function () {
          return {
            username: '',
            password: '',
            remember: false
          }
        }
      },
      loading: {
        type: Boolean,
        default: false
      },
      demoVisible: {
        type: Boolean,
        default: true
      },
      demoUrl: {
        type: String,
        default: ''
      },
      errorDelay: {
        type: Number,
        default: 5000
      }
    },
    watch: {
      error() {
        if (this.timer) {
          clearTimeout(this.timer)
        }

        this.timer = setTimeout(() => {
          this.error = ''
        }, this.errorDelay)
      }
    },
    data: function () {
      return {
        error: ''
      }
    },
    methods: {
      click: function () {
        this.$emit('login', this.form);
      },
      focus: function (e) {
        if (e.target.type == 'text') {
          e.target.type = 'password';
        }
      },
      remembered: function () {
        this.form.remember = !this.form.remember;
      }
    },
    computed: {
      demoLink: function () {
        return (this.demoUrl ? this.demoUrl : 'http://demo.365qczx.com/') + 'Login_Demo.aspx?OutUrl=' + window.location.href;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .w-login {
    padding: 20px;
    width: 300px;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 100px;
    z-index: 1;
    color: #fff;
    border-radius: 8px;
    height: 330px;

    &__title {
      font-size: 24px;
      display: block;
      color: #fff;
      margin-bottom: 30px;
      margin-top: 15px;
      text-align: center;
      //letter-spacing: 0.5em;
    }

    &__input {
      height: 45px;
      margin-bottom: 20px;
      background-color: #FFF;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 5px;
      border-radius: 2px;

      &_icon {
        color: #606266;
        height: 45px;
        width: 45px;
        display: flex;
        font-size: 20px;
        align-items: center;
        justify-content: center;
      }

      input {
        flex-grow: 1;
        height: 45px;
        -webkit-appearance: none;
        border: none;
        background-color: transparent;
        color: #303133;
        font-size: 14px;
        outline: none;

        &:-webkit-autofill {
          transition-delay: 99999s !important;
          transition: color 99999s ease-out, background-color 99999s ease-out !important;
          -webkit-transition-delay: 99999s !important;
          -webkit-transition: color 99999s ease-out, background-color 99999s ease-out !important;
        }

        &::placeholder {
          font-size: 14px;
        }
      }
    }

    &__remember {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      transform: translateY(-15px);

      .icon {
        font-size: 16px;
      }

      .remember {
        cursor: pointer;
      }

      .demo {
        display: block;
        flex-grow: 1;
        text-align: right;

        a {
          color: #fff;
          text-decoration: none;

          &:hover {
            color: #F56C6C;
          }
        }
      }
    }

    &__btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      button {
        flex-grow: 1; // background-color: #409EFF;
        background-color: #E66464;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border: 0;
        padding: 0;
        margin: 0;
        height: 100%;
        color: #FFF;
        font-size: 14px;
        cursor: pointer;
        border-radius: 8px;
        outline: none;
        //letter-spacing: 0.5em;

        &:hover {
          // background-color: #66b1ff;
          background-color: #F56C6C;
        }

        &.loading {
          cursor: no-drop; // background-color: #66b1ff;
          background-color: #F56C6C;
        }
      }
    }

    &__error {
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
    }

    &__options {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-bottom: 10px;

      &_flex {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;

        a {
          // color: #53a8ff;
          color: #F56C6C;
          text-decoration: none;

          &:hover {
            color: #FA9191;
          }
        }

        span {
          margin-bottom: 10px;
        }
      }
    }
  }

  .icon-loading {
    animation: loading 1s linear infinite;
  }

  @keyframes loading {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes loading {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @-moz-keyframes loading {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @-ms-keyframes loading {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/config/w-login.vue